import moment from 'moment';
import estadisticasDiarioFormModel from './estadisticasDiarioFormModel';

const {
    formField: {
        nombre_cliente,
        startDate,
        endDate
    }
} = estadisticasDiarioFormModel;

export default {
    [nombre_cliente.name]: undefined,
    [startDate.name]: '',
    [endDate.name]: '',
};
